<template>
    <div class="modal fade" id="modalUpdateInvoiceBillingDate" role="dialog">
      <div
        class="modal-dialog modal-dialog-centered modal-scroll"
      >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title black-text" style="font-weight: bold" v-if="isExclude">
                Exclude / Modify Billing Cycle
              </h4> 
              <h4 class="modal-title black-text" style="font-weight: bold" v-else>
                Update All Billing Cycle  
              </h4> 
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
                <div class="mr-2 mb-4">
                    <div class="mb-2">{{ isExclude ? 'Apakah anda ingin mengubah Billing Cycle ?': 'Billing Cycle'}} </div>   
                    <input type="date" class="form-control w-100" name="invoice_billing_date" :value="billingCycle" @input="onchangeBillingCycle">
                </div>
                <div class="d-flex flex-row" v-if="!isExclude">
                    <input type="checkbox" aria-label="Checkbox for following text input" @change="confirmChange" v-if="!isChangeAllBillingCycle ">
                    <input type="checkbox" aria-label="Checkbox for following text input" @change="confirmChange" checked v-else>
                
                    <span class="check-box-text ml-3"> 
                      {{`Ubah semua billing cycle di bulan-bulan berikutnya ke tanggal ${new Date(billingCycle).getDate()}`}} 
                    </span>
                </div>
                <div style="text-align : center;">
                    <button class="btn btn-small btn-primary mt-3" @click="updateInvoiceBillingDate()">
                        Save
                    </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ModalUpdateInvoiceBillingDate',
  props: ['isExclude', 'billingCycle','setNewBillingCycle', 'executeChanges'],
  data () {
    return {
        isChangeAllBillingCycle : false
    }
  },
  methods:{
    onchangeBillingCycle(event) {
      this.setNewBillingCycle(event.target.value)
    },
    confirmChange () {
        this.isChangeAllBillingCycle = !this.isChangeAllBillingCycle 
    },
    updateInvoiceBillingDate () {
      this.executeChanges(this.isExclude ? false : this.isChangeAllBillingCycle)
    },
    closeModal(name){
      $("#modal"+name).modal('hide')
    },
  },
  created(){
    // this.getData()
    // this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .check-box-text {
    color: #2E3646;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
    letter-spacing: -0.016px;
  }

  .most-overdue-title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-text {
    color: #2E3646;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-orange {
    color: #FF5252;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/ModalUpdateInvoiceBillingDate.vue